module.exports = __webpack_public_path__ + "static/media/cover-automatic-sprinkler-systems.146ea34f.jpg";